



















































import { Component, Prop } from "vue-property-decorator";
import { Action, Getter, Mutation } from "vuex-class";
import { IPagination } from "@/types";
import { IProposal, IProposalListRequest } from "@/types/proposal";
import { ProposalListRequest } from "@/models/proposal";
import List from "@/components/basic/List.vue";

@Component({
  components: {},
})
export default class extends List {
  @Action("proposal/salesGetList")
  public getProposalList!: (params: IProposalListRequest) => Promise<boolean>;

  @Getter("proposal/list")
  public proposalList!: IProposal[];

  @Getter("proposal/pagination")
  public pagination!: IPagination<IProposal>;

  @Mutation("proposal/clear")
  protected clear!: () => void;

  @Prop()
  public search!: string;

  @Prop()
  public status!: number | string;

  public params = new ProposalListRequest();

  public headers = [
    {
      text: "title",
      align: "start",
      value: "title",
    },
    { text: "対象", value: "members", sortable: false },
    { text: "ステータス", value: "proposal_status_id" },
    { text: "報酬", value: "reward_lower", sortable: false },
    { text: "概要", value: "summary", sortable: false },
  ];

  public member_id = 0;

  public async mounted() {
    this.member_id = Number(this.$route.params.member_id);
  }

  // override
  public async getList() {
    this.loading = true;
    this.params.search = this.search;
    if (this.status === "inprogress") {
      this.params.inprogress = true;
      this.params.status = 0;
    } else if (typeof this.status === "number") {
      this.params.inprogress = false;
      this.params.status = this.status;
    }
    if (this.member_id) {
      this.params.member_id = this.member_id;
    }
    await this.getProposalList(this.params);
    this.loading = false;

    this.paramsToQuery();
  }

  public rowClick(proposal: IProposal): void {
    if (this.member_id) {
      this.$router.push({
        name: "SalesMemberProposalDetail",
        params: {
          member_id: this.member_id.toString(),
          proposal_id: proposal.id.toString(),
          ticket_id: proposal.id.toString(),
        },
      });
    } else {
      this.$router.push({
        name: "SalesProposalDetail",
        params: { proposal_id: proposal.id.toString() },
      });
    }
  }
}
